const getGlobalState = (state, key) => (Array.isArray(state.autobooking[key]) ? state.autobooking[key].slice(0) : state.autobooking[key]);

export const getIntervals = (state) => getGlobalState(state, 'intervals') || null;
export const getWeekSummary = (state) => getGlobalState(state, 'weekSummary') || null;
export const getEditedDays = (state) => getGlobalState(state, 'editedDays') || [];
export const getTennisIntervals = (state) => getGlobalState(state, 'tennisIntervals') || null;
export const getTennisWeekSummary = (state) => getGlobalState(state, 'tennisWeekSummary') || null;
export const getTennisEditedDays = (state) => getGlobalState(state, 'tennisEditedDays') || [];
export const getAddIntervalError = (state) => getGlobalState(state, 'addIntervalError');
export const isModified = (state) => getGlobalState(state, 'isModified');
export const getTempLink = (state) => getGlobalState(state, 'tempLink');
